import { render, staticRenderFns } from "./QEditDxLeadOrderForm.vue?vue&type=template&id=80da4f12&"
import script from "./QEditDxLeadOrderForm.vue?vue&type=script&lang=js&"
export * from "./QEditDxLeadOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./QEditDxLeadOrderForm.vue?vue&type=style&index=0&id=80da4f12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports